import React, { useRef, useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import type { Swiper as SwiperType } from 'swiper';
import 'swiper/css';
import InspirationGallery from './InspirationGallery';
import ResponsiveMyStylistPage from './ResponsiveMyStylistPage';
import './MyStylistPage.css';
import { parseReportJson, useReportContext } from '../../ReportContext';
import { usePrimaryGender } from '../../PersonalReport/Utils/PrimaryGenderContext';
import { trackPageView } from '../../../utils/analytics';

const MyStylistPage: React.FC = () => {
  const swiperRef = useRef<SwiperType | null>(null);
  const [isMobile, setIsMobile] = useState(false);
  const [showAccessPage, setShowAccessPage] = useState(false);
  // TODO: gender可从全局context获取
  const { defaultReport } = useReportContext();
  const { primaryGender } = usePrimaryGender();

  // 页面加载埋点
  useEffect(() => {
    trackPageView('My Stylist Page', { page: '/my-stylist' });
  }, []);

  // Get gender preference: primaryGender 优先，其次从 report 中解析，最后默认 Female
  let defaultGender: 'Male' | 'Female' = 'Female';

  if (primaryGender === 'Male' || primaryGender === 'Female') {
    defaultGender = primaryGender;
  } else if (defaultReport) {
    try {
      const parsed = parseReportJson(defaultReport.reportDetail);
      const rawGender = parsed.facialData.gender;
      if (rawGender === 'Male' || rawGender === 'Female') {
        defaultGender = rawGender;
      }
    } catch {
      // ignore parse errors and keep default 'Female'
    }
  }

  // 检测是否为移动端
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 900);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    document.body.style.overflow = 'auto';
    document.documentElement.style.overflow = 'auto';
    window.scrollTo(0, 0);
  }, []);

  // 切换到细节access
  const handleCustomize = () => {
    setShowAccessPage(true);
  };
  
  // 切回主access
  const handleBack = () => {
    setShowAccessPage(false);
  };

  // Mobile 端：使用 state 控制内容切换
  if (isMobile) {
    return (
      <div className="my-stylist-page-mobile">
        {!showAccessPage ? (
          <InspirationGallery gender={defaultGender} onCustomize={handleCustomize} />
        ) : (
          <div className="mobile-access-page">
            <button className="back-btn" onClick={handleBack}>← Back to Style Gallery</button>
            <ResponsiveMyStylistPage />
          </div>
        )}
      </div>
    );
  }

  // Desktop 端：和 mobile 一致，使用 state 控制内容切换
  return (
    <div className="my-stylist-page-desktop">
      {!showAccessPage ? (
        <InspirationGallery gender={defaultGender} onCustomize={handleCustomize} />
      ) : (
        <div className="desktop-access-page">
          <button className="back-btn" onClick={handleBack}>← Back to Style Gallery</button>
          <ResponsiveMyStylistPage />
        </div>
      )}
    </div>
  );
};

export default MyStylistPage;
